import styled from 'styled-components';

export const CarriersSelectionStyled = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  .carriersSelectionContainer {
    &__selectors {
      display: flex;
      gap: 8px;
      align-items: center;
      &__countrySelector {
        width: 160px;

        .singleSelectorComponent {
          width: 160px;
        }
      }

      &__carriersSelector {
        width: 422px;
      }
    }
    &__addButton {
      
    }
  }
`;
